import React from "react";
import { LoadingWrap } from "./Table.style";

/**
 * LoadingState – table loading placeholder. Used by Table when loading=true.
 * @param {{ message?: string }} props
 */
export default function LoadingState({ message = "Loading..." }) {
  return <LoadingWrap>{message}</LoadingWrap>;
}
